<template>
  <div>
    <UiBackdrop :is-open="isOpen" class="md:hidden" :close="() => toggle(false)" />
    <SfDropdown
      :id="`${id}-dropdown`"
      :model-value="isOpen"
      :data-testid="`${id}-dropdown`"
      :class="wrapperClass"
      @update:model-value="toggle"
    >
      <template #trigger>
        <UiButton
          :id="`${id}-dropdown-trigger`"
          variant="navigation"
          type="neutral"
          :icon="IconChevron"
          :icon-class="isOpen ? 'rotate-180' : ''"
          icon-side="right"
          :class="buttonClass"
          @click="toggle()"
        >
          <slot name="selected" />
        </UiButton>
      </template>

      <ul
        class="fixed left-1/2 top-1/2 z-20 max-h-96 w-[90%] max-w-sm -translate-x-1/2 -translate-y-1/2 space-y-2 overflow-y-auto rounded-md bg-white p-4 shadow-md md:static md:left-auto md:top-auto md:z-auto md:w-max md:transform-none"
      >
        <slot />
      </ul>
    </SfDropdown>
  </div>
</template>

<script setup lang="ts">
import { IconChevron } from '#components';

import type { DropdownProps } from '~/components/ui/Dropdown/types';

defineProps<DropdownProps>();
</script>
